import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Select, Typography, message } from 'antd'
import Utils from '../../../utils/Utils'

const { Title } = Typography
const { Option } = Select

function FelDrawer(props) {
  const [company_id, setCompanyId] = useState('')
  const [usuario, setUsuario] = useState('')
  const [password, setPassword] = useState('')
  const [afiliacion_iva, setAfiliacionIva] = useState('')
  const [tipo_frase, setTipoFrase] = useState('')
  const [codigo_escenario, setCodigoEscenario] = useState('')
  const [nit_certificador, setNitCertificador] = useState('')
  const [nombre_certificador, setNombreCertificador] = useState('')
  const [regimen_certificador, setRegimenCertificador] = useState('')

  const [loadingField, setLoadingField] = useState(true)
  /*Info for selects*/
  const [enterprises, setEnterprises] = useState([])

  const loadInformation = () => {
    setCompanyId(props.edit ? props.editData.company_id : null)
    setUsuario(props.edit ? props.editData.usuario : '')
    setPassword('')
    setAfiliacionIva(props.edit ? props.editData.afiliacion_iva : '')
    setTipoFrase(props.edit ? props.editData.tipo_frase : '')
    setCodigoEscenario(props.edit ? props.editData.codigo_escenario : '')
    setNitCertificador(props.edit ? props.editData.nit_certificador : '')
    setNombreCertificador(props.edit ? props.editData.nombre_certificador : '')
    setRegimenCertificador(props.edit ? props.editData.regimen_certificador : '')
  }

  useEffect(() => {
    loadInformation()

    if (props.visible) {
      onSearchEnterprise('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const saveData = () => {
    let data = {
      company_id: validateParams(company_id, 'Empresa', false) ? company_id : undefined,
      usuario: validateParams(usuario, 'Usuario Digifact') ? usuario : undefined,
      afiliacion_iva: validateParams(afiliacion_iva, 'Afiliación IVA') ? afiliacion_iva : undefined,
      tipo_frase: validateParams(tipo_frase, 'Tipo de frase') ? tipo_frase : undefined,
      codigo_escenario: validateParams(codigo_escenario, 'Código escenario') ? codigo_escenario : undefined,
      fel_id: props.edit ? props.editData.fel_id : 0,
    }

    // Al editar, dejar la contraseña en blanco significa "no cambiarla" — no se
    // envía el campo. Al crear, sí es obligatoria.
    if (!props.edit || password !== '') {
      data.password = validateParams(password, 'Contraseña Digifact') ? password : undefined
    }

    let boolValidate = true
    for (let k in data) {
      if (boolValidate) {
        const d = data[k]
        d === '' || d === undefined || d === null ? (boolValidate = false) : (boolValidate = true)
      }
    }

    if (boolValidate) {
      // Campos del certificador: no son obligatorios, se agregan aparte para
      // que no entren en la validación de campos requeridos de arriba.
      data.nit_certificador = nit_certificador
      data.nombre_certificador = nombre_certificador
      data.regimen_certificador = regimen_certificador

      props.saveButton(data, props.edit)
    }
  }

  const validateParams = (val, strMessage, boolInteger = false, paramsMessage) => {
    if (val === '' || val === null) {
      if (boolInteger) {
        return !Number.isInteger(val * 1) || val * 1 <= 0 ? message.warning(strMessage) : true
      }
      return message.warning(`El campo ${strMessage} no debe estar vacio`)
    } else {
      return true
    }
  }

  const onSearchEnterprise = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOption(val, excludeChars, 'desc')
      .then(response => {
        setEnterprises(response.data.data)
        setLoadingField(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }

  return (
    <Drawer className={'entreprise-drawer'} placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
      <Row gutter={16}>
        <Title> {props.edit ? 'Editar Credencial' : 'Nueva Credencial'} </Title>
        <Divider className={'divider-custom-margins-users'} />
        {/*Fields section*/}
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Empresa*</div>
            <Select
              disabled={loadingField}
              showSearch
              optionFilterProp="children"
              onSearch={onSearchEnterprise}
              value={company_id}
              className={'single-select'}
              placeholder={'Elegir empresa'}
              size={'large'}
              style={{ width: '100%' }}
              onChange={value => setCompanyId(value)}
              getPopupContainer={trigger => trigger.parentNode}
            >
              {enterprises &&
                enterprises.map(data => {
                  return (
                    <Option key={data.id} value={data.id}>
                      {data.name}
                    </Option>
                  )
                })}
            </Select>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Usuario Digifact*</div>
            <Input value={usuario} onChange={value => setUsuario(value.target.value)} placeholder={'Usuario que Digifact asignó'} size={'large'} />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Contraseña Digifact*</div>
            <Input.Password
              value={password}
              onChange={value => setPassword(value.target.value)}
              placeholder={props.edit ? 'Escribe una nueva contraseña para cambiarla' : 'Contraseña de Digifact'}
              size={'large'}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Afiliación IVA*</div>
            <Input
              value={afiliacion_iva}
              onChange={value => setAfiliacionIva(value.target.value)}
              placeholder={'Ej. GEN'}
              size={'large'}
            />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Tipo de frase*</div>
            <Input
              value={tipo_frase}
              onChange={value => setTipoFrase(value.target.value)}
              placeholder={'Código de tipo de frase SAT'}
              size={'large'}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Código escenario*</div>
            <Input
              value={codigo_escenario}
              onChange={value => setCodigoEscenario(value.target.value)}
              placeholder={'Código de escenario SAT'}
              size={'large'}
            />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Divider className={'divider-custom-margins-users'} />
            <div className={'title-space-field'} style={{ fontWeight: 600 }}>Datos del certificador (se muestran en el ticket)</div>
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>NIT del certificador</div>
            <Input
              value={nit_certificador}
              onChange={value => setNitCertificador(value.target.value)}
              placeholder={'NIT de Digifact'}
              size={'large'}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Nombre del certificador</div>
            <Input
              value={nombre_certificador}
              onChange={value => setNombreCertificador(value.target.value)}
              placeholder={'Ej. DIGIFACT SERVICIOS, S.A.'}
              size={'large'}
            />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Régimen del certificador</div>
            <Input
              value={regimen_certificador}
              onChange={value => setRegimenCertificador(value.target.value)}
              placeholder={'Régimen fiscal del certificador'}
              size={'large'}
            />
          </Col>
        </Row>

        {/*End Fields section*/}
      </Row>

      {/*Footer buttons section*/}
      <Row gutter={16}>
        <Divider className={'divider-custom-margins-users'} />
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button type={'link'} className="cancel-button" onClick={() => props.cancelButton()}>
                Cancelar
              </Button>
              <Button htmlType="submit" className="title-tendero new-button" onClick={() => saveData()}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      {/*End Footer buttons section*/}
    </Drawer>
  )
}

export default FelDrawer
